import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {firstValueFrom} from "rxjs";
import {
  AddressInfoFormData
} from "../pages/update-profile-section/update-address-info/update-address-info-form.service";
import {
  FormCurrentHouseholdMember,
  FormHouseholdMember
} from "../pages/update-profile-section/update-household-members-info/update-household-members-form.service";

type FlowDraftTypeMap = {
  'address-info': AddressInfoFormData;
  'household-member': FormCurrentHouseholdMember;
  'household-members': FormHouseholdMember[];
};

type FlowType = keyof FlowDraftTypeMap;

@Injectable({
  providedIn: 'root'
})
export class FlowDraftService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/api/private/flow-drafts`;

  async get<T extends FlowType>(flowType: T): Promise<FlowDraftTypeMap[T] | undefined> {
    const result = await firstValueFrom(
      this.http.get<FlowDraftTypeMap[T] | null>(`${this.baseUrl}/${flowType}`)
    );
    return result ?? undefined;
  }

  async save<T extends FlowType>(flowType: T, data: FlowDraftTypeMap[T]): Promise<void> {
    await firstValueFrom(
      this.http.put(`${this.baseUrl}/${flowType}`, data, {responseType: 'text'})
    );
  }

  async delete(flowType: FlowType): Promise<void> {
    await firstValueFrom(
      this.http.delete(`${this.baseUrl}/${flowType}`, {responseType: 'text'})
    );
  }
}
